import React, { useCallback, useEffect, useState } from 'react';
import Styles from './PlanDetailScreen.module.scss';
import SubscriptionCard from './SubscriptionCard';
import { SUBSCRIBE_PLAN } from 'constants';
import Header from 'Components/Pages/PricingPlans/Header';
import useFetchPlans from 'hooks/subscriptions/fetchPlans';
import HorizontalTestimonials from '../../Components/Testimonials/HorizontalTestimonials';

const Subscription = ({
  closeDrawer,
  refetch,
  handlePlanSelect,
  context,
  hideTestimonials = false, // New prop to hide testimonials
  ...props
}) => {
  const [currentTab, setCurrentTab] = useState(2); // Changed from 1 to 2 to default to yearly
  const [subscriptionPlans, setSubscriptionPlans] = useState(
    props.subscriptionPlans ?? {},
  );
  const [currentSubscription, setCurrentSubscription] = useState(
    props.currentSubscription ?? null,
  );
  const [lastSubscription, setLastSubscription] = useState(
    props.lastSubscription ?? null,
  );
  const [paymentMethods, setPaymentMethods] = useState(
    props.paymentMethods ?? {},
  );

  const fetchPlansData = useFetchPlans();
  const fetchPlans = useCallback(async (setShouldRedirect) => {
    if (
      !(
        props.subscriptionPlans &&
        props.lastSubscription &&
        props.currentSubscription &&
        props.paymentMethods
      )
    ) {
      fetchPlansData({
        setPaymentMethods,
        setSubscriptionPlans,
        setCurrentSubscription,
        setLastSubscription,
        setShouldRedirect,
      });
    }
  }, []);

  useEffect(() => {
    fetchPlans();
  }, [fetchPlans]);

  useEffect(() => {
    setCurrentSubscription(props.currentSubscription);
  }, [props.currentSubscription]);

  const renderTab = useCallback(() => {
    // Determine context based on usage
    const context = closeDrawer ? 'drawer' : 'page';

    switch (currentTab) {
      case 1:
        return (
          <SubscriptionCard
            plan={subscriptionPlans.monthlyPlan}
            currentSubscription={currentSubscription}
            lastSubscription={lastSubscription}
            refetch={refetch ?? fetchPlans}
            hasPaymentMethod={Boolean(paymentMethods)}
            closeDrawer={closeDrawer}
            setProductData={props.setProductData}
            setTrial={props.setTrial}
            fullHeight={true}
            useTableLayout={true}
            handlePlanSelect={handlePlanSelect}
            context={context}
            // setSummaryData={props.setSummaryData}
          />
        );
      case 2:
        return (
          <SubscriptionCard
            plan={subscriptionPlans.annualplan}
            currentSubscription={currentSubscription}
            lastSubscription={lastSubscription}
            refetch={refetch ?? fetchPlans}
            hasPaymentMethod={Boolean(paymentMethods)}
            closeDrawer={closeDrawer}
            setProductData={props.setProductData}
            fullHeight={true}
            useTableLayout={true}
            handlePlanSelect={handlePlanSelect}
            context={context}
            // setSummaryData={props.setSummaryData}
          />
        );
      default:
        return <h1>Something went wrong</h1>;
    }
  }, [
    currentSubscription,
    currentTab,
    fetchPlans,
    lastSubscription,
    subscriptionPlans.annualplan,
    subscriptionPlans.monthlyPlan,
    handlePlanSelect,
    closeDrawer, // Add to dependencies
  ]);

  const isPlanCanceled =
    currentSubscription?.status === 'canceled' && currentSubscription?.active;

  const isSubscribePlan = window.location.pathname.includes(SUBSCRIBE_PLAN);

  const handleToggleClick = () => {
    // Toggle between tabs based on the current tab
    const newTabId = currentTab === 1 ? 2 : 1;
    setCurrentTab(newTabId);
  };

  return (
    <>
      <div className={Styles.layout}>
        <div className={Styles.header}>
          <Header
            isChecked={currentTab === 2}
            handleToggleClick={handleToggleClick}
          />
          {closeDrawer && (
            <button className={Styles.close_btn} onClick={closeDrawer}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M15 5L5 15M5 5L15 15"
                  stroke="#344054"
                  strokeWidth="1.67"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          )}
        </div>
        {renderTab()}

        {/* Testimonials Section - Only show when user doesn't have active subscription */}
        {!currentSubscription?.active && !hideTestimonials && (
          <HorizontalTestimonials
            senjaApiKey="O22b0Cqtm3MwiwC0fqMfOc3vmbJW"
            speed={300}
            limit={1000} // Fetch 1000 testimonials
            minRating={0} // Allow all ratings since Senja data has rating: 0
            enableLengthFiltering={true} // Enable length filtering
            minLength={200} // Minimum 200 characters - changed from 300
            maxLength={300} // Maximum 300 characters - changed from 500
          />
        )}
      </div>
    </>
  );
};

export default Subscription;
